<!-- Footer Section -->
<footer class="footer">
  <div class="container">
    <div class="row gy-4">
      <div class="col-md-4">
        <div class="footer-col1">
          <div class="footer-logo">
            <img class="logo" src="https://insizon-email-templates-bucket.s3.us-east-2.amazonaws.com/dropaddy/dropaddy-v3-wordmark-main.png" alt="DropAddy" />
          </div>
          <p>
            Discover exclusive parties and connect with your community
          </p>
          <div class="social-icons">
            <a  (click)="noLink()"><i class="fa-brands fa-facebook"></i></a>
            <a (click)="noLink()"><i class="fa-brands fa-instagram"></i></a>
            <a (click)="noLink()"><i class="fa-brands fa-x-twitter"></i></a>
          </div>
        </div>
      </div>

      <div class="col-md-4">
        <div class="footer-links">
          <h6>Quick Links</h6>
          <ul>
            <li><a [href]="getFeatureLink" target="_blank">Features</a></li>
            <li><a href="#how-it-works">How it Works</a></li>
            <li><a href="#">Download</a></li>
            <li><a [href]="getBugRepoLink" target="_blank">Report Bugs</a></li>
          </ul>
        </div>
      </div>

      <div class="col-md-4">
        <div class="footer-contact">
          <h6>Get in Touch</h6>
          <ul>
            <li>
              <i class="fa-solid fa-envelope"></i>business&#64;insizon.com
            </li>
            <li><i class="fa-solid fa-phone"></i> +1 (555) 123-4567</li>
            <li>
              <a style="color:inherit" [href]="getContactUsLink" target="_blank"><i class="fa-solid fa-globe"></i> Contact Support </a>
            </li>
          </ul>
        </div>
      </div>
    </div>

    <div class="footer-bottom">
      <p>© {{ currentYear }} DropAddy. <a [href]="insizonUrl"> All rights reserved. </a></p>
      <div class="footer-policy">
          <a href="privacy-policy">Privacy Policy</a>
        | <a href="terms-of-services">Terms of Service</a>
        | <a href="safety-policy">Safety Policy</a>
      </div>
    </div>
  </div>
</footer>
<p-toast></p-toast>
